import template from './voucher.html';
import controller from './voucher.controller';

let voucherComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default voucherComponent;
